var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#BADEE2;}\r\n\t.st2{fill:#588210;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st3{fill:#000002;}\r\n\t.st4{fill:#C9C9C9;}\r\n\t.st5{fill:url(#SVGID_1_);}\r\n\t.st6{fill:#DBDBDB;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 76.6,
  y: 130.1,
  className: "st1",
  width: 365.4,
  height: 218.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M76.6,334.5c0,0,14.3-3.8,18.3-3.2s13.8-4.3,13.8-4.3s13.8-6.2,20.8-5.1c7,1.1,24-7.3,28.9-7.3 c4.9,0,9.7-3.5,11.1,3.8c1.3,7.3-7.6,14.8-9.2,17.8c-1.6,3-4.3,12.4-4.3,12.4l-79.3-1.6V334.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M343,134.1c0,0,4.7,2.6,2.8,6.7c-1.8,4,8.7,15.2,10.3,16c1.6,0.8,16.6,4.2,16,0s0-16.8,8.9-21.5 C389.9,130.6,343,134.1,343,134.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M186.1,147.6c-3.5-0.3-9.6-14.7-9.6-14.7s41.1-11.5,59.1-5.5c17.9,5.9-6.6,28.6-6.6,28.6s-32.9,0.4-34.4-4.3 C193.1,146.9,186.1,147.6,186.1,147.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M194.4,342.6c0,0-20-4.3-20.2-11.5c-0.3-7.1-5.1-14.1-3.5-16c1.6-1.9,6.4-6.2,11.7-6.7 c5.3-0.5,10.7-5.9,10.7-9.7c0-3.8,1.3-23.5,4-27.2c2.7-3.8,7-7.8,10.8-7.6c3.8,0.3,12.4-2.4,10.2-12.4c-2.2-10-9.7-13.8-9.7-18.3 s-2.2-30.5-4.3-35.3c-2.2-4.9-7.5-11.9-9.7-12.4c-2.2-0.5-3.2-12.7-4.9-16.4c-1.6-3.8-3.5-9.4-2.7-12.4s-0.8-8.9-0.8-8.9 s5.9-10,8.4-7s9.4,12.4,11.6,11.6s9.6-4,12.5-4c1.9,0,4.4,0,6.5,1c1.1,0.5,3.1,1.9,2.7-0.9c-0.2-1.1-0.2-2.1,0.2-2.7 c1.3-2.2,1.3-9.7,4-10s14.3-1.3,14.8,5.4c0.5,6.7-1.1,18.6-5.9,20.5c-4.9,1.9-0.8,5.1-0.8,5.1s3,2.7-0.3,6.2 c-3.2,3.5,10.8,6.2,13.8,5.4c3-0.8,5.4,0,10,7s11.1,2.7,13,5.1c1.9,2.4,3,7,7.8,8.4c4.9,1.3-5.4,10.8-2.4,15.4 c3,4.6,2.2,10.2-0.8,13.8c-3,3.5,0.3,14.8-3.2,15.6s-23.2,3.5-24,7.6c-0.8,4-7.3,7.3-8.1,7.3s-2.2,15.4-1.9,23.2s5.1,11.3-4,17.8 c-9.2,6.5-12.9,3.2-17.8,14.5c-4.3,7.9-5.9,6.2-6.5,9.7S210.6,356.1,194.4,342.6z"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M440.2,122.2H78.4c-6.1,0-11.1,5-11.1,11.1v249.8c0,6.1,5,11.1,11.1,11.1h361.8c6.1,0,11.1-5,11.1-11.1V133.3 C451.3,127.1,446.3,122.2,440.2,122.2z M436.2,343.4h-355v-208h355V343.4z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M213.5,423.5c0,0-32.1,10.2-14.3,10.8c17.8,0.5,115.4,0,115.4,0s20.2-1.6,3.2-5.3c-17-3.6-21.8-19.5-21.8-19.5 L213.5,423.5z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M212.8,423.5h93c0,0-6.2-6.2-6.2-35.1c0-28.9-79.6-12.5-79.6-12.5S220.9,418.3,212.8,423.5z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M440.4,394.2H78.1c-6.1,0-11.1-5-11.1-11.1v-24.9l384.5-0.5v25.4C451.6,389.2,446.6,394.2,440.4,394.2z"
});
function SvgMappa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 512,
    height: 512,
    xlinkHref: "mappa.png",
    transform: "matrix(0.8404 0 0 0.8404 47.0557 45.1241)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.2811,
    y1: 423.4719,
    x2: 259.2811,
    y2: 371.3019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8B8B"
    }
  })), _ref6, _ref7));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappa);
export default __webpack_public_path__ + "static/media/mappa.20b8c59b9794e8adda47a8e6e6ae5ca3.svg";
export { ForwardRef as ReactComponent };